import { CONFIG } from "../../config";
import { getTokenizedAxios } from "../../utils/axiosWithTokenGen";
import {
  IKlearlyAdmin,
  EmployeeType,
} from "../../interfaces/klearlyAdmin.interface";

export async function getKlearlyAdminsFromServer(params?: {
  employeeType?: EmployeeType;
  search?: string;
}): Promise<{ admins: IKlearlyAdmin[] }> {
  const axios = await getTokenizedAxios();
  const path = "/account/klearly-admins";
  return axios
    .get(CONFIG.ADMIN_SERVER.BASE_URL + path, { params })
    .then((data) => data?.data);
}

export async function createKlearlyAdminServer(
  admin: Partial<IKlearlyAdmin>
): Promise<{ admin: IKlearlyAdmin }> {
  const axios = await getTokenizedAxios();
  const path = "/account/klearly-admins";
  return axios
    .post(CONFIG.ADMIN_SERVER.BASE_URL + path, { admin })
    .then((data) => data?.data);
}

export async function editKlearlyAdminServer(
  admin: Partial<IKlearlyAdmin>
): Promise<IKlearlyAdmin> {
  const axios = await getTokenizedAxios();
  const path = "/account/klearly-admins";
  return axios
    .put(CONFIG.ADMIN_SERVER.BASE_URL + path, { admin })
    .then((data) => data?.data);
}

export async function deleteKlearlyAdminServer(email: string): Promise<{
  success: boolean;
  message: string;
}> {
  const axios = await getTokenizedAxios();
  const path = "/account/klearly-admins";
  return axios
    .delete(CONFIG.ADMIN_SERVER.BASE_URL + path, { data: { admin: { email } } })
    .then((data) => data?.data);
}
